<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>

            <CRow>
              <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                <strong>{{ $t('PeriodReportAmountCirc') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                <CButton @click="load_data" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
                <CButton
                        class="mr-1"
                        size="sm"
                        @click="print_with_header(body_id,'print_report_header','print_report_footer')"
                        color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>
              </CCol>

            </CRow>
          </CCardHeader>
          <br>
          <div v-show="false">
            <div id="print_report_header" class="border-dark">
              <CCardHeader>
                <CRow style="border: 1px solid #000">

                  <CCol sm="4" md="4" style="text-align: right">
                    <h2>{{ get_date(new Date()) }}</h2>

                  </CCol>
                  <CCol sm="4" md="4" style="text-align: center">
                    <h2>{{ $t('periodReport') }}</h2>

                  </CCol>
                  <CCol sm="4" md="4" style="text-align: left">
                    <CImg :src="get_logo()" width="100px" height="50px"/>

                  </CCol>
                </CRow>

              </CCardHeader>

            </div>
            <div id="print_report_footer" class="border-dark">
              <CCardHeader>
                <CRow style="border: 1px solid #000">


                  <CCol sm="4" md="4" style="text-align: start">
                    <h2>{{ $t('docCreator') }} : {{ get_user_name() }}</h2>
                  </CCol>
                  <CCol sm="4" md="4" style="text-align: center">
                    <h2 id="pageFooter" class="pageFooter"></h2>
                  </CCol>
                  <CCol sm="4" md="4" style="text-align: end">
                    <h2>
                      SP 100
                    </h2>
                  </CCol>
                </CRow>

              </CCardHeader>

            </div>
          </div>

          <CCardBody id="body_customer_bill" >
            <CDataTableFixed
                    :items="items_customer"
                    :fields="fields"
                    height="60vh"
                    :items-per-page="20"
                    hover
                    border
                    sorter
                    column-filter
                    striped
            >
              <template #row_id="{item,index}">

                <td>
                  <p style="text-align: center">{{ index + 1 }}</p>

                </td>

              </template>
              <template #120-header>
                <p class="mb-0">{{$t('PastDue')}} 120</p>
                <p>{{$t('days')}}</p>
              </template>
              <template #90-header>
                <p class="mb-0">{{$t('PastDue')}} 90</p>
                <p>{{$t('days')}}</p>
              </template>
              <template #60-header>
                <p class="mb-0">{{$t('PastDue')}} 60</p>
                <p>{{$t('days')}}</p>
              </template>
              <template #30-header>
                <p class="mb-0">{{$t('PastDue')}} 30</p>
                <p>{{$t('days')}}</p>
              </template>
              <template #current-header>
                <p class="mb-0"></p>
                <p>{{$t('current')}}</p>
              </template>
              <template #balance-header>

                <p class="mb-0">{{$t('tables.balance')}}</p>
                <p></p>
              </template>

              <template #120="{item}">
                <td style="text-align: right;">
                  <label v-if="item.before_120>0">
                    {{get_currency(item.before_120) }}</label>
                  <label v-else>0</label>
                </td>
              </template>
              <template #90="{item}">
                <td style="text-align: right;">
                  <label v-if="item.before_90>0">
                    {{get_currency(item.before_90) }}</label>
                  <label v-else>0</label>
                </td>
              </template>
              <template #60="{item}">
                <td style="text-align: right;">
                  <label v-if="item.before_60>0">
                    {{get_currency(item.before_60) }}</label>
                  <label v-else>0</label>
                </td>
              </template>
              <template #30="{item}">
                <td style="text-align: right;">
                  <label v-if="item.before_30>0">
                    {{get_currency(item.before_30) }}</label>
                  <label v-else>0</label>
                </td>
              </template>
              <template #current="{item}">
                <td style="text-align: right;">
                  <label v-if="item.before_current>0">
                    {{get_currency(item.before_current) }}</label>
                  <label v-else>0</label>
                </td>
              </template>

              <template #balanceCurrent="{item}">
                <td style="text-align: right;">
                    <label>
                      {{get_currency(item.balanceCurrent) }}</label>
                </td>
              </template>


              <template #caption>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style="font-weight: bold">{{ get_currency(calculate_items(items_customer,"before_120")) }}</td>
                  <td style="font-weight: bold">{{ get_currency(calculate_items(items_customer,"before_90")) }}</td>
                  <td style="font-weight: bold">{{ get_currency(calculate_items(items_customer,"before_60")) }}</td>
                  <td style="font-weight: bold">{{ get_currency(calculate_items(items_customer,"before_30")) }}</td>
                  <td style="font-weight: bold">{{ get_currency(calculate_items(items_customer,"before_current")) }}</td>
                  <td style="font-weight: bold">{{ get_currency(calculate_items(items_customer,"balanceCurrent")) }}</td>

                </tr>
<!--                <CRow>-->
<!--                  <CCol></CCol>-->
<!--                  <CCol></CCol>-->
<!--                  <CCol></CCol>-->
<!--                  <CCol></CCol>-->
<!--                  <CCol></CCol>-->
<!--                  <CCol></CCol>-->
<!--                  <CCol class="bg-dark">{{ $t('tables.balance') }}</CCol>-->
<!--                  <CCol class="bg-dark">{{ get_sum_debtor(items_customer) + get_sum_credetor(items_customer) }}</CCol>-->
<!--                  <CCol></CCol>-->

<!--                  <CCol></CCol>-->
<!--                </CRow>-->

              </template>
            </CDataTableFixed>

          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
  import axios from "axios";
  import {bus} from '../../../../main';
  import Vue from "vue";
  import Treeselect from '@riophae/vue-treeselect'

  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  import moment from 'moment-jalaali'


  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }
  export default {
    name: 'Login',
    components: {
      Treeselect,
    },
    data() {
      return {
        body_id: 'body_customer_bill',
        confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
        VUE_APP_Currency: localStorage.getItem('currency'),
        items_customer: [],
        start_date: '',

        types_all: [],
        types_parent: [],
        selected_type_parent: 0,
        selected_type_child: 0,

        end_date: '',
        fields: [//amount amountNegetive accBalance accBalanceNegetive
          {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:5%',filter:false},
          {key: 'personCode', label: this.$t('tables.code'), _style: 'width:5%'},

          {key: 'personName', label: this.$t('name'), _style: 'width:10%'},
          {key: '120', label: '120 '+this.$t('days'), _style: 'width:10%',filter:false},
          {key: '90', label: '90 '+this.$t('days'), _style: 'width:10%',filter:false},
          {key: '60', label: '60 '+this.$t('days'), _style: 'width:10%',filter:false},
          {key: '30', label: '30 '+this.$t('days'), _style: 'width:10%',filter:false},
          {key: 'current', label: '30 Aug جاری', _style: 'width:10%',filter:false},
          {key: 'balanceCurrent', label: this.$t('tables.balance'), sorter: true, _style: 'width:10%',filter:false},

          // {key: 'amountNegetive', label: this.$t('tables.debtor'), _style: 'width:10%'},
          // {key: 'amount', label: this.$t('tables.creditor'), _style: 'width:10%'},
          // {key: 'accBalanceNegetive', label: this.$t('tables.debtorBalance'), _style: 'width:10%'},
          // {key: 'accBalance', label: this.$t('tables.creditBalance'), _style: 'width:10%'},
          // {key: 'statusTitle', label: this.$t('tables.documentType'), _style: 'width:10%'},
          // {key: 'kardexAccTypeTitle', label: this.$t('tables.type'), _style: 'width:10%'},
          // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},

          // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

        ],

        normalizer_accounting(node) {
          return {
            id: node.id,
            label: node.accountCode + " " + node.accountName,
          }
        },
        normalizer_accounting_tafzili(node) {
          return {
            id: node.recId,
            label: node.title,
          }
        },
        load_persons({action, searchQuery, callback}) {

          if (action === ASYNC_SEARCH) {
            simulateAsyncOperation(() => {
              let options;
              const formData = new FormData();

              formData.append('SearchTxt', searchQuery);
              var url = "GetAllPersons";

              formData.append('IsVendor', false);
              formData.append('IsWorker', false);
              formData.append('IsCustomer', true);
              formData.append('IsActive', 0);

              axios.post(url, formData, {show_pros: true}).then(function (response) {
                options = response.data.data;

                callback(null, options);

              })
                      .catch(function (error) {

                        console.log(error);
                      });

            })
          }
        },
        normalizer_persons(node) {
          return {
            id: node.userId,
            label: node.fullName + " " + node.mobileNo,
          }
        },
        templates_items: [],
        accounting_list: [],
        moein_list: [],
        tafsili_list: [],
        selected_person: null,
        selected_moein: null,
        selected_tafsili: null,
        collapseDuration: 0,
        person_name: '',
        status_form: 0,

        route_items: [],
        selected_route: 0,

        area_items: [],
        selected_area: 0,

        province_items: [],
        selected_province: 0,

        city_items: [],
        selected_city: 0,

        district_items: [],
        selected_district: 0,

        country_items: [],
        selected_country: 0,

      }
    }, mounted() {

      this.$root.root_validate_errors = [];
      // this.get_lists_groups();
      // this.get_types();
      this.get_country()
      this.get_routes()
      // this.get_all_customers()

      // this.get_lists();
      this.start_date = this.get_day_before_today(1);
      this.end_date = this.get_today();

      bus.$on(this.confirm_delete_name, (data) => {
        // alert(data);
        if (data == "true") {
          this.delete_item();

        } else {
          this.status_form = 0;
        }
      });
    }, watch: {
      'selected_type_parent': function () {
        if(this.selected_type_parent==10){
          this.body_id = 'body_customer_bill';
        }
        if(this.selected_type_parent==15){
          this.body_id = 'body_customer_all_person';
        }
        if(this.selected_type_parent==13){
          this.body_id = 'body_all_customer';
        }
        if(this.selected_type_parent==14){
          this.body_id = 'body_customers_bill';
        }
      },
      'selected_province': function () {
        this.get_cities();
      },
      'selected_city': function () {
        this.get_districts();
      },
      'selected_district': function () {
        this.get_areas();
      },
      'selected_country': function () {
        this.get_provinces();
      },
    },
    methods: {

      get_country() {
        var self = this;

        const formData = new FormData();


        // formData.append('id', this.selected_province);


        axios.post('GetCountries', formData, {}).then(function (response) {

          var content_data = response.data;

          // items = content_cats.orders;
          if (content_data.statusCode == 0) {

            self.country_items = [];

            self.country_items = self.sort_array(
                    self.country_items, content_data.data,
                    'id', 'title');

            if (self.$i18n.locale == 'fa') {
              self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
            }
            if (self.$i18n.locale == 'en') {
              self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
            }

          } else {
            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

          }


        })
                .catch(function (error) {

                  console.log(error);
                });

      },
      get_provinces() {
        var self = this;

        const formData = new FormData();


        formData.append('id', this.selected_country);


        axios.post('GetStateList', formData, {}).then(function (response) {

          var content_data = response.data;

          // items = content_cats.orders;
          if (content_data.statusCode == 0) {
            self.province_items = [];

            self.province_items = self.sort_array(
                    self.province_items, content_data.data,
                    'id', 'provinceName');


            self.selected_province = self.province_items[0].value;

          } else {
            self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

          }


        })
                .catch(function (error) {

                  console.log(error);
                });

      },
      get_cities() {
        var self = this;

        const formData = new FormData();


        formData.append('id', this.selected_province);

        axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

          var content_data = response.data;

          // items = content_cats.orders;
          if (content_data.statusCode == 0) {
            // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
            //         fields;
            self.city_items = []
            self.city_items = self.sort_array(
                    self.city_items, content_data.data,
                    'cityId', 'cityName');

            self.selected_city = self.city_items[0].value;

          } else {
            self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

          }


        })
                .catch(function (error) {

                  console.log(error);
                });

      },
      get_districts() {
        var self = this;

        const formData = new FormData();


        formData.append('id', this.selected_city);

        axios.post('GetRegionByCityId', formData, {show_pros: true}).then(function (response) {

          var content_data = response.data;

          // items = content_cats.orders;
          if (content_data.statusCode == 0) {
            // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
            //         fields;
            self.district_items = []
            self.district_items = self.sort_array(
                    self.district_items, content_data.data,
                    'id', 'title');

            self.selected_district = self.district_items[0].value;

          } else {
            self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

          }


        })
                .catch(function (error) {

                  console.log(error);
                });

      },
      get_areas() {
        var self = this;

        const formData = new FormData();


        formData.append('id', this.selected_district);

        axios.post('GetAreaTitlesByCityId', formData, {show_pros: true}).then(function (response) {

          var content_data = response.data;

          // items = content_cats.orders;
          if (content_data.statusCode == 0) {
            // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
            //         fields;
            self.area_items = []
            self.area_items = self.sort_array(
                    self.area_items, content_data.data,
                    'id', 'areaName');

            // content_data.data.forEach((val) => {
            //   var obj = {label: val.areaName, value: val.id}
            //
            //   self.area_items.push(obj);
            // });
            self.selected_area = self.area_items[0].value;
          } else {
            self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

          }


        })
                .catch(function (error) {

                  console.log(error);
                });

      },
      get_routes() {
        var self = this;

        const formData = new FormData();

        axios.post('GetRoutesNew', formData, {}).then(function (response) {

          var content_data = response.data;

          // items = content_cats.orders;
          if (content_data.statusCode == 0) {
            self.route_items = [{label: self.$t('all'), value: 0}]
            self.route_items = self.sort_array(self.route_items, content_data.data, 'id', 'title')
            self.selected_route = self.route_items[0].value;


          } else {
            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
          }

        })
                .catch(function (error) {

                  console.log(error);
                });

      },

      get_style(color) {
        return {
          myStyle: {
            backgroundColor: color
          }
        }
      },
      get_sum_debtor(list) {
        var sum = 0;
        list.forEach((val) => {
          sum += val.amountNegetive;
        })
        return sum;
      },
      get_sum_credetor(list) {
        var sum = 0;
        list.forEach((val) => {
          sum += val.amount;
        })
        return sum;
      },

      load_data() {
        // if(this.selected_type_parent==10){
          this.get_lists();
        // }
        // if(this.selected_type_parent==15){
        //   this.get_lists_all_person();
        // }
      },
      get_lists() {
        var self = this;


        const formData = new FormData();

        var url = "GetCredDeptRpt";

        formData.append('CityId', this.selected_city);
        formData.append('ProvinceId', this.selected_province);
        formData.append('RegionId', this.selected_district);
        formData.append('AreaId', this.selected_area);
        formData.append('RouteId', this.selected_route);
        formData.append('CountryId', this.selected_country);
        axios.post(url, formData, {}).then(function (response) {

          var content_data = response.data;
          // items = content_cats.orders;
          if (content_data.statusCode == 0) {
            self.items_customer = content_data.data;
            self.items_customer.forEach(function (val) {
              val.before_90 = val.balance90
              if(val.before_90<0){
                val.before_90 = 0;
              }
              val.before_60 = val.balance60
              if(val.before_60<0){
                val.before_60 = 0;
              }
              val.before_30 = val.balance30
              if(val.before_30<0){
                val.before_30 = 0;
              }
              val.before_current =  val.currentDays
              if(val.before_current<0){
                val.before_current = 0;
              }
              val.before_120 =  val.balanceCurrent -( val.before_current + val.before_30 + val.before_60 + val.before_90)

            })
          } else {
            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

          }

        })
                .catch(function (error) {

                  console.log(error);
                });

      },

    }
  }

</script>
